// Extracao de URLs de texto livre (post inteiro, lista, mensagem copiada).
// Puro e sem dependencias: roda no painel (contagem ao vivo) e na edge (lote).

const URL_PATTERN = /\b(?:https?:\/\/|www\.)[^\s<>"'`{}|\\^]+/gi;
const TRAILING_PUNCTUATION = /[.,;:!?\]'"»”’…*_~]+$/u;
const MAX_URL_LENGTH = 2048;

/** URLs na ordem em que aparecem (com repeticao), normalizadas para http(s). */
export function extractUrls(text: string): string[] {
  const matches = text.match(URL_PATTERN) ?? [];
  return matches.flatMap((raw) => {
    const trimmed = stripTrailing(raw);
    const withScheme = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
    return isUsableUrl(withScheme) ? [withScheme] : [];
  });
}

function stripTrailing(raw: string): string {
  let value = raw;
  for (let next = stripOnce(value); next !== value; next = stripOnce(value)) {
    value = next;
  }
  return value;
}

/** Remove pontuacao final; ")" so sai se nao fechar um "(" da propria URL. */
function stripOnce(value: string): string {
  const withoutPunctuation = value.replace(TRAILING_PUNCTUATION, "");
  const hasUnbalancedClose =
    withoutPunctuation.endsWith(")") &&
    count(withoutPunctuation, "(") < count(withoutPunctuation, ")");
  return hasUnbalancedClose ? withoutPunctuation.slice(0, -1) : withoutPunctuation;
}

function count(value: string, char: string): number {
  return value.split(char).length - 1;
}

function isUsableUrl(value: string): boolean {
  if (value.length > MAX_URL_LENGTH) {
    return false;
  }
  try {
    const parsed = new URL(value);
    return (
      (parsed.protocol === "http:" || parsed.protocol === "https:") && parsed.hostname.includes(".")
    );
  } catch {
    return false;
  }
}

/** Chave de igualdade textual: host sem www, sem fragmento, sem barra final. */
export function normalizeUrlKey(url: string): string {
  try {
    const parsed = new URL(url);
    const host = parsed.hostname.toLowerCase().replace(/^www\./, "");
    const path = parsed.pathname.replace(/\/+$/, "");
    return `${host}${path}${parsed.search}`;
  } catch {
    return url.trim();
  }
}
